import React from 'react';
import ContentCard from 'Shared/ContentCard';
import { onView, onClick } from 'Shared/ContentCard/DataLayer';
import ViewTracker from '../../ViewObserver/ViewTracker';
import * as styles from './base.scss';
export default function ProductCardListLargeAd(props) {
    return React.createElement(ViewTracker, { key: 'largeAdViewTracker', onView: (e) => onView(e, props.largeAd) },
        React.createElement(ContentCard, Object.assign({}, props.largeAd, { appearance: "large", key: "Ad", className: styles.ad, onClick: (e) => onClick(e, props.largeAd) })));
}
